import AccountApi from "./modules/account.api";
import AdminApi from "./modules/admin.api";
import AlertApi from "./modules/alert.api";
import ArticleApi from "./modules/article.api";
import AuthApi from "./modules/auth.api";
import CallcenterApi from "./modules/callcenter.api";
import CollaborationApi from "./modules/collaboration.api";
import CouponApi from "./modules/coupon.api";
import CourseApi from "./modules/course/course.api";
import DiscountApi from "./modules/discount.api";
import IntegrationApi from "./modules/integration.api";
import ItemApi from "./modules/item.api";
import MultimediaApi from "./modules/multimedia.api";
import ProjectApi from "./modules/project.api";
import StatisticsApi from "./modules/statistics.api";
import TarifficationApi from "./modules/tariffication.api";
import UserApi from "./modules/user.api";
import VerificationApi from "./modules/verification.api";
import HelpApi from "./modules/help.api";

export default class Api {
  static account = new AccountApi();
  static admin = new AdminApi();
  static alert = new AlertApi();
  static article = new ArticleApi();
  static auth = new AuthApi();
  static callcenter = new CallcenterApi();
  static collaboration = new CollaborationApi();
  static coupon = new CouponApi();
  static course = new CourseApi();
  static discount = new DiscountApi();
  static integration = new IntegrationApi();
  static item = new ItemApi();
  static multimedia = new MultimediaApi();
  static project = new ProjectApi();
  static statistics = new StatisticsApi();
  static tariffication = new TarifficationApi();
  static user = new UserApi();
  static verification = new VerificationApi();
  static HelpApi = new HelpApi();
}
